module.exports = __webpack_public_path__ + "wf.e73b57847157661bc2aa.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/wf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/wf.svg
// module chunks = styles